export default defineNuxtPlugin((nuxtApp) => {
    return // disabled for now

    const config = useAppConfig()
    // if (config.RUN_MODE === 'development') return // add Google Analytics only in production mode

    if (process.client) {
        const url = new URL(window.location.href)

        const source = url.searchParams.get('utm_source') || url.searchParams.get('ref') || (document.referrer ? new URL(document.referrer).hostname : 'direct')

        // Only set if not already set
        if (!localStorage.getItem('fw_traffic_source')) {
            localStorage.setItem('fw_traffic_source', source)
        }

        console.log('💠 traffic_source', source)
    }
})
